export default __webpack_public_path__ + "static/media/mail.b3be6aa7.svg";